module.exports = __webpack_public_path__ + "static/media/grammy.8cf77f00.svg";